module.exports = __webpack_public_path__ + "img/stick_divers_recharge_prise.fb6998c3.svg";